<template>
  <div id="app">
    <div v-if="logged == true" id="nav">
      <nav class="navbar is-light" role="navigation" aria-label="main navigation" >
        <div class="navbar-brand">
          <a class="navbar-item" href="https://meteo.smprzylesie.pl">
            SM PRZYLESIE
          </a>

          <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" @click="isOpen = !isOpen" v-bind:class="{'is-active': isOpen}">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>

        </div>
        
        <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{'is-active': isOpen}"> 
          <div class="navbar-start">
            <a class="navbar-item">
              <router-link to="/">Dashboard</router-link> 
            </a>

            <a class="navbar-item">
              <router-link to="/charts">Wykresy</router-link>
            </a>

            
          </div>

          <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                <a v-if="role == 0" class="button  is-light" @click="settings">
                  Ustawienia
                </a>
                <a class="button is-light "  @click="logout">
                  Log out
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    
      
    </div>
    <div v-if="logged == false" id="nav2">
      <nav class="navbar is-light" role="navigation" aria-label="main navigation" >
        <div class="navbar-brand">
          <a class="navbar-item" href="https://meteo.smprzylesie.pl">
            SM PRZYLESIE
          </a>

          
        </div>

        <div id="navbarBasicExample" class="navbar-menu">
          

          <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                
                
              </div>
            </div>
          </div>
        </div>
      </nav>
    
      
    </div>
    <router-view/>
    <Settings></Settings>
  </div>
</template>
<script>
  import Settings  from '@/components/Settings.vue'
    export default {
        name: "App",
        data() {
          return {
            isOpen: false
          }
        },
        components:{
          Settings
        },
        computed: {
          
          logged(){
            return this.$store.getters.logged
          },
          role(){
            return this.$store.getters.role
          }
        },
        methods: {
          settings(){
           

            var set = document.getElementById("settings")
            
            set.classList.add("is-active");
          },
          logout(){
            
            this.$store.dispatch("logout");
            this.$router.push({ path: '/login' });
          }
        },
    }
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
 
}

#nav {
  padding: 0px;
  
}

#nav a {
  font-weight: bold;
  
}
/*
#nav a.router-link-exact-active {
  //color: white;
}

.dark .navbar-start>a.navbar-item:hover {
    //background-color: #292929;
    color: #fff;
}*/
</style>
